import type {
  ContactFormLeadTriggerObject,
  ContactFormTriggerLocation,
} from 'app/shared/models/Clickstream/ContactClickstreamEvents';
import type { ListingDetails } from 'app/types/listingDetails.type';
import { useDetailPanel } from '../../../ui/DetailPanel';
import { ContactFormSpoke } from './ContactFormSpoke';

/**
 * DetailPanel-compatible wrapper for ContactFormSpoke.
 * Rendered inside DetailPanelOutlet on desktop.
 *
 * Accepts an optional `config.listing` from the DetailPanel's config mechanism,
 * used when opened from contexts where Redux's currentListingDetails isn't populated
 * (e.g., the FeedView on the SRP).
 */
export const ContactFormSpokeContent = ({ config }: { config?: unknown }) => {
  const { closePanel } = useDetailPanel();
  const typedConfig = config as
    | {
        listing?: ListingDetails;
        triggerLocation?: ContactFormTriggerLocation;
        triggerObject?: ContactFormLeadTriggerObject;
      }
    | undefined;

  return (
    <ContactFormSpoke
      onClose={closePanel}
      listing={typedConfig?.listing}
      triggerLocation={typedConfig?.triggerLocation}
      triggerObject={typedConfig?.triggerObject}
    />
  );
};
